// SCSS Imports
import "./AccessDeniedModal.scss";

// React Imports
import React, { useState } from "react";

// Component Imports

// Image Imports

// Font Awesome Icons

const AccessDeniedModal = ({ onClose }) => {
    return (
        <div className="modal-overlay">
            <div className="modal">
                <h1>Oh no!</h1>
                <p>
                    You do not have an active subscription to view this video.
                </p>
                <p className="first-login-note">
                    First time logging in? If you just subscribed, it can take up
                    to 5 minutes for your access to activate. Please wait a few
                    minutes and try again &mdash; we apologize for the inconvenience.
                </p>
                <a href="https://brainbased-wellness.com/membership/">
                    Subscribe Now
                </a>
                <button onClick={onClose}>Exit</button>
            </div>
        </div>
    );
};
export default AccessDeniedModal;
